<h1 mat-dialog-title>
    <span [translate]="'admin.bibliotheque.notifications.relances.selectRolesPopin.popinTitle'"></span>
    <span [mat-dialog-close]><i class="zmdi zmdi-close"></i></span>
</h1>
<div mat-dialog-content>
    <list-view *ngIf="listeRoles" [liste]="listeRoles"></list-view>
</div>
<div mat-dialog-actions>
    <button mat-flat-button color="primary" [mat-dialog-close]="listeRoles.listeObjetsSectionnes">
        <span [translate]="'global.actions.confirmer'"></span>
    </button>
</div>